import "./tripstyles.css";
import TripData from "./tripdata";
import Trip1 from "../assets/5.webp";
import Trip2 from "../assets/8.webp";
import Trip3 from "../assets/6.jpg";

function Trip() {
  return (
    <div className="trip obj-width">
      <h1>Recent Trips</h1>
      <p>You can discover unique destinations using Google Maps.</p>
      <div className="tripcard">
        <TripData
          image={Trip1}
          heading="Trip in Hunza Valley"
          text="Hunza Valley, situated in northern Pakistan, is renowned for its breathtaking landscapes and lush green terraces. Nestled between the majestic peaks of the Karakoram Range, it offers a unique blend of natural beauty and cultural richness. The valley is home to vibrant communities who maintain traditional lifestyles amidst snow-capped mountains and crystal-clear rivers."
        />
        <TripData
          image={Trip2}
          heading="Trip in Naran & Kaghan Valley"
          text="Naran and Kaghan, located in northern Pakistan, are celebrated for their stunning landscapes and serene natural beauty. Known for their picturesque lakes, lush green valleys, and towering mountains, these areas offer a refreshing escape into nature. The region features a unique blend of local cultures and traditions, set against a backdrop of pristine scenery and tranquil environments."
        />
        <TripData
          image={Trip3}
          heading="Trip in Gilgit"
          text="Gilgit, in northern Pakistan, boasts dramatic mountain ranges, lush valleys, and ancient historical sites. The city, surrounded by towering peaks, is renowned for its stunning natural beauty, including the serene Hunza River and the majestic Karakoram range. Visitors are drawn to its rich cultural heritage and breathtaking landscapes."
        />
      </div>
    </div>
  );
}

export default Trip;
